// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__V1MJe","rootSuccess":"CompleteLink_rootSuccess__1SHv8","rootFailure":"CompleteLink_rootFailure__Uj7Zm","isDisabled":"CompleteLink_isDisabled__1bU5l"};